export default __webpack_public_path__ + "static/media/backWhite.7eb5cbca.svg";